/** Limits unbounded growth if the user never logs out. */
const MAX_MESSAGE_IDS = 400;

const claimedMessageIds = new Set<string>();

/** chatId (canonical) -> epoch ms until which incoming-call push should be hidden (WS won). */
const wsCallSuppressUntil = new Map<string, number>();

const WS_CALL_SUPPRESS_MS = 18_000;

function canonChatKey(id: string): string {
  return id.trim().replace(/-/g, '').toLowerCase();
}

/**
 * First successful claimant (WebSocket path or Expo push presentation) wins; the other path skips
 * duplicate UI/sound.
 */
export function tryClaimMessageNotify(messageId: string): boolean {
  if (claimedMessageIds.has(messageId)) return false;
  claimedMessageIds.add(messageId);
  while (claimedMessageIds.size > MAX_MESSAGE_IDS) {
    const first = claimedMessageIds.values().next().value as string | undefined;
    if (first === undefined) break;
    claimedMessageIds.delete(first);
  }
  return true;
}

export function markIncomingCallHandledFromWebSocket(chatId: string): void {
  wsCallSuppressUntil.set(canonChatKey(chatId), Date.now() + WS_CALL_SUPPRESS_MS);
}

export function shouldSuppressIncomingCallPush(chatId: string): boolean {
  const key = canonChatKey(chatId);
  const until = wsCallSuppressUntil.get(key);
  if (until == null) return false;
  if (Date.now() > until) {
    wsCallSuppressUntil.delete(key);
    return false;
  }
  return true;
}

export function resetPushNotifyDedupeState(): void {
  claimedMessageIds.clear();
  wsCallSuppressUntil.clear();
}
